import { Component } from '@angular/core';
import { LoadingService } from './loading.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-global-loading',
    imports: [CommonModule],
    template: `
    <div class="global-loading" *ngIf="loadingService.loading$ | async">
      <div class="conversely-loader">
        <div class="conversely-favicon"></div>
        <div class="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  `,
    styles: [`
    .global-loading {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999999999;
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        display: flex;
        justify-content: center;
        align-items: center;
        pointer-events: all; 
    }

    .conversely-loader {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.5rem;
    }

    .conversely-favicon {
      width: 64px;
      height: 64px;
      background-image: url('/logo.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      animation: conversely-pulse 2s ease-in-out infinite;
      filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
    }

    .loading-dots {
      display: flex;
      gap: 6px;
      align-items: center;
    }

    .loading-dots span {
      width: 8px;
      height: 8px;
      background: #070738;
      border-radius: 50%;
      animation: dot-pulse 1.5s ease-in-out infinite;
    }

    .loading-dots span:nth-child(1) {
      animation-delay: 0s;
    }

    .loading-dots span:nth-child(2) {
      animation-delay: 0.3s;
    }

    .loading-dots span:nth-child(3) {
      animation-delay: 0.6s;
    }

    @keyframes conversely-pulse {
      0% { 
        transform: scale(1);
        opacity: 0.8;
      }
      50% { 
        transform: scale(1.1);
        opacity: 1;
      }
      100% { 
        transform: scale(1);
        opacity: 0.8;
      }
    }

    @keyframes dot-pulse {
      0%, 80%, 100% {
        transform: scale(0.8);
        opacity: 0.5;
      }
      40% {
        transform: scale(1);
        opacity: 1;
      }
    }
  `]
})
export class GlobalLoadingComponent {
    constructor(public loadingService: LoadingService) { }
}
